import { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { getAccountState } from '@/account/state'
import { requestCarouselBanner } from '@/events/state'

import styled from 'styled-components'
const Container = styled.div`
  left: 0;
  margin-top: 100px;
  width: 100vw;
  ul {
    /* border: 1px dashed black; */
    position: relative;
    overflow-x: hidden;
    height: 180px;
    display: flex;
    list-style: none;
    li {
      position: absolute;
      width: 100vw;
      transition: 1s;
      img {
        z-index: 0;
        margin: 0;
        min-width: 100vw;
        width: 100%;
      }
    }
  }
  @media (min-width: 600px) {
    display: none;
  }
`
const Information = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  /* border:1px dashed black; */
  height: 160px;
  .social-button {
    &,
    span {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    span {
      width: 50px;
      height: 50px;
      background: #fff;
      margin: 10px 15px;
      padding: 5px;
      border: 1px solid gray;
      border-radius: 10px;
      img {
        width: 80%;
      }
    }
  }
  @media (max-width: 600px) {
    &,
    .social-media {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
`
const Bullet = styled.span`
  border-radius: 50%;
  width: 15px;
  height: 15px;
  margin: 0 5px;
  background-color: gray;
  cursor: pointer;
  &.active {
    background-color: var(--bg-primary);
  }
`

const DELAY_TRANSITION = 3000

function MobileCarousel ({ sliderData }) {
  const dispatch = useDispatch()
  const { sellonToken } = useSelector(getAccountState)
  const { apikey, nationCode } = sellonToken

  const maxSlide = sliderData.length
  const [transition, setTransition] = useState(1)
  const timeoutRef = useRef(null)

  const transiting = () => {
    if (transition + 1 === maxSlide) setTransition(0)
    else setTransition(transition + 1)
  }
  const resetTimeout = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current)
  }

  useEffect(() => {
    dispatch(requestCarouselBanner({ apikey, nation_code: nationCode }))
  }, [])
  useEffect(() => {
    resetTimeout()
    timeoutRef.current = setTimeout(transiting, DELAY_TRANSITION)
    return () => {
      resetTimeout()
    }
    // transiting()
    // window.addEventListener('load', transiting);

    // return () => {
    //     window.removeEventListener('load', transiting);
    // };
  }, [transition])
  return (
    <Container>
      <ul>
        {sliderData.map((item, i) => (
          <li key={i} style={{ right: `${(transition - i) * 100}vw` }}>
            {item.src ? <img alt={`img ${i}`} src={item.src} /> : item}
          </li>
        ))}
      </ul>
      <Information>
        <ul>
          {sliderData.map((_, idx) => (
            <Bullet
              key={idx}
              className={idx === transition ? 'active' : 'inactive'}
              onClick={() => setTransition(idx)}
            />
          ))}
        </ul>
        <div className="social-media">
          <p>FOLLOW US </p>
          <div className="social-button">
            <a
              href="https://api.whatsapp.com/send?phone=6588562024"
              target="_blank"
            >
              <span>
                <img src={'/media/logo/whatsapp.png'} alt="Community" />
              </span>
            </a>
            <a href="http://facebook.com/sellonsg" target="_blank">
              <span>
                <img src={'/media/logo/facebook.png'} alt="Community" />
              </span>
            </a>
            <a href="http://instagram.com/sellon_sg" target="_blank">
              <span>
                <img src={'/media/logo/instagram.png'} alt="Community" />
              </span>
            </a>
          </div>
        </div>
      </Information>
    </Container>
  )
}

export default MobileCarousel
